function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgBroadcastLargeOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.929 18.778a.5.5 0 0 0 0-.707c-3.905-3.905-3.905-10.237 0-14.142C8.834.024 15.166.024 19.07 3.929c3.905 3.905 3.905 10.237 0 14.142a.5.5 0 1 0 .707.707c4.296-4.296 4.296-11.26 0-15.556-4.296-4.296-11.26-4.296-15.556 0-4.296 4.296-4.296 11.26 0 15.556a.5.5 0 0 0 .707 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.757 15.95a.5.5 0 0 0 0-.707 6 6 0 1 1 8.486 0 .5.5 0 0 0 .707.707 7 7 0 1 0-9.9 0 .5.5 0 0 0 .707 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.958 23.299-4.309-9.792a3 3 0 1 0-3.298 0l-4.308 9.792c-.211.48.366.92.773.589L12 19.676l5.185 4.212c.407.331.984-.109.773-.59Zm-3.966-6.53-1.258-2.86a3.01 3.01 0 0 1-1.467 0l-1.258 2.86L12 18.387l1.992-1.618Zm-1.199 2.263 1.617-1.314 1.799 4.088-3.416-2.774Zm-1.585 0L9.59 17.718l-1.799 4.088 3.415-2.774ZM14 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgBroadcastLargeOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgBroadcastLargeOutlinedIcon);
export default Memo;